import { ReactNode, useMemo } from 'react'

import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'

import {
  GetAdminProjectQuery,
  GetProjectByUriQuery
} from 'src/config/generated/graphql'
import { ArrayElement } from 'src/types/common'
import { camelToFlat } from 'src/utils/common'

// Note: Figma uses `--secondary-1-50` = `rgba(234,238,118,0.5)` for the chip bg
// (limeFresh at 50% opacity) and `#08441b` for text + `opacity-80` on the body
// paragraph.
type ProjectContentProps = {
  projectData:
    | ArrayElement<GetProjectByUriQuery['Project']>
    | ArrayElement<GetAdminProjectQuery['Project']>
  rightColumn?: ReactNode
}

export const ProjectContent = ({
  projectData,
  rightColumn
}: ProjectContentProps) => {
  const purposes = useMemo(
    () => (projectData?.Purpose || []) as Array<string>,
    [projectData]
  )

  const { Description } = projectData

  return (
    <div className='flex flex-col gap-6'>
      <TypographyRebrand variant='h4' color='forestDeep'>
        About the project
      </TypographyRebrand>

      {purposes.length > 0 && (
        <div className='flex flex-row flex-wrap gap-2 items-center'>
          {purposes.map(p => (
            <span
              key={`purpose-${p}`}
              className='font-body-rebrand text-[12px] font-bold leading-[1.6] text-forestDeep bg-limeFresh/50 rounded-full px-3 py-1'
            >
              {camelToFlat(p)}
            </span>
          ))}
        </div>
      )}

      <div className='flex flex-col lg:flex-row gap-8 lg:gap-12 items-stretch lg:items-start'>
        {Description && (
          <p className='flex-1 min-w-0 font-body-rebrand text-base md:text-[20px] leading-[1.6] text-forestDeep/80 whitespace-pre-wrap m-0'>
            {Description}
          </p>
        )}
        {rightColumn && (
          <div className='w-full lg:w-[526px] shrink-0'>{rightColumn}</div>
        )}
      </div>
    </div>
  )
}
